import { render } from "./Aries.vue?vue&type=template&id=5518f581&scoped=true"
import script from "./Aries.vue?vue&type=script&lang=js"
export * from "./Aries.vue?vue&type=script&lang=js"

import "./Aries.vue?vue&type=style&index=0&id=5518f581&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5518f581"]])

export default __exports__